import { Vue } from "nuxt-property-decorator";
import VueNotification from "vue-notification";

Vue.use(VueNotification);
